import React from 'react';
import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { OrderPayload } from 'pages/reference-implementation/provisioning/RI003/store';
import ProjectSection from 'pages/reference-implementation/provisioning/RI003/components/sections/Project';
import ApplicationSection from 'pages/reference-implementation/provisioning/RI003/components/sections/Application';
import AccessMgmtSection from 'pages/reference-implementation/provisioning/RI003/components/sections/AccessMgmtSection';

const IndexForm = () => {
    const order = useRecoilValue(OrderPayload);
    return (
        <Box flex={3}>
            <ProjectSection />
            <ApplicationSection />
            {!['production']?.includes(order?.environment?.toLowerCase()) && <AccessMgmtSection />}
        </Box>
    );
};

export default IndexForm;
